import {Component, Input} from '@angular/core';
import {Pollen, PollenflugRegion} from '../../../../../../../model/vorhersagen/pollenflug';

@Component({
  selector: 'app-pollenflug-region',
  templateUrl: './pollenflug-region.component.html',
  styleUrls: ['./pollenflug-region.component.css']
})
export class PollenflugRegionComponent {

  @Input()
  region: PollenflugRegion;

  getPollenSortedByNameAscending(): Pollen[] {
    return this.region.pollen.sort((pollen1, pollen2) => pollen1.name.localeCompare(pollen2.name));
  }

}
